import React from "react";

import {
  ModalOverlay,
  Wrapper,
  Modal,
  Card,
  CardBody,
  Title,
  Copy,
  Bold,
  PrimaryButton,
  SecondaryButton,
  DeleteButton
} from "app/NativeComponents/common";

import { TextButton } from "app/NativeComponents/snippets";

const MailingAddressMore = props => {
  if (props.show_options) {
    return (
      <ModalOverlay isVisible={true} onPress={() => props.toggleOptions()}>
        <Modal actionSheet>
          <Card
            style={{
              minWidth: "95%",
              paddingBottom: props.device == "mobile" ? 10 : 0
            }}
          >
            <CardBody>
              <Title style={{ textAlign: "center" }}>
                Options for {props.mailing_address.address}
              </Title>
              <Copy style={{ textAlign: "center" }}>Select an option</Copy>
            </CardBody>

            <Card style={{ borderRadius: 30, overflow: "hidden" }}>
              <SecondaryButton
                onPress={() => {
                  props.setEditModal({
                    title: "Edit Mailing Address",
                    description:
                      "Edit mailing address for " + props.owner_info.owner_name,
                    slug: "edit-owner-mailing-address",
                    type: "edit_owner_mailing_address",
                    fields: {
                      address: props.mailing_address.address,
                      address2: props.mailing_address.address2,
                      city: props.mailing_address.city,
                      state: props.mailing_address.state,
                      zip: props.mailing_address.zip,
                      send_to_address: props.mailing_address.send_to_address
                    },
                    save_button_text: "Edit",
                    modalAction: ({ fields }) => {
                      props.updateOwnerInfo({
                        token: props.token,
                        deal_id: props.active_property.deal.id,
                        owner_mailing_address_id:
                          props.mailing_address.owner_mailing_address_id,
                        type: "edit_mailing_address",
                        address: fields.address,
                        address2: fields.address2,
                        city: fields.city,
                        state: fields.state,
                        zip: fields.zip,
                        send_to_address: fields.send_to_address,
                        onSuccess: () => {}
                      });
                    },
                    cancelAction: () => {},
                    fieldsUpdated: fields => {},
                    can_remove: false
                  });

                  props.appRedirect({
                    redirect: "goForward",
                    payload: { add: "edit-owner-mailing-address" }
                  });
                  props.toggleOptions();
                }}
              >
                Edit Mailing Address
              </SecondaryButton>
            </Card>

            <Card style={{ borderRadius: 30, overflow: "hidden" }}>
              <DeleteButton
                onPress={() => {
                  props.setModal({
                    title: "Remove Mailing Address",
                    description:
                      "Are you sure you want to remove this mailing address?",
                    icon: "delete",
                    submit: "Remove Mailing Address",
                    buttonType: "destroy",
                    onPress: () => {
                      props.updateOwnerInfo({
                        token: props.token,
                        deal_id: props.active_property.deal.id,
                        owner_mailing_address_id:
                          props.mailing_address.owner_mailing_address_id,
                        type: "remove_mailing_address"
                      });
                    },
                    cancel: "Cancel",
                    onCancel: () => {}
                  });
                  props.toggleModal({ show: true, type: "normal" });
                  props.toggleOptions();
                }}
              >
                Remove Mailing Address
              </DeleteButton>
            </Card>

            <TextButton onPress={() => props.toggleOptions()} text={"Cancel"} />
          </Card>
        </Modal>
      </ModalOverlay>
    );
  }

  return null;
};

export default MailingAddressMore;
